import { jsx as _jsx } from "react/jsx-runtime";
import { domToReact } from 'html-react-parser';
import { useMedia } from '@tribeplatform/react-sdk/hooks';
import { FileListItem } from '../common/components/FileListItem';
import { hasPreview } from '../Composer/components';
export const AttachmentRenderer = ({ domNode, attachments, onClick, slides, pushSlide, }) => {
    var _a, _b;
    // Fetch the corresponding attachment id
    const attachmentId = domNode.attribs['data-id'];
    const initialData = attachments === null || attachments === void 0 ? void 0 : attachments.find(attachment => attachment.id === attachmentId);
    const { data: media, isLoading } = useMedia({
        variables: {
            id: attachmentId,
        },
        fields: {
            onFile: 'basic',
        },
        useQueryOptions: {
            initialData,
            cacheTime: Infinity,
            staleTime: Infinity,
            enabled: !!attachmentId,
        },
    });
    if (isLoading) {
        return (_jsx("figure", { children: _jsx(FileListItem, { name: "" }, void 0) }, void 0));
    }
    if (!media) {
        return null;
    }
    const file = media;
    const canBePreviewed = hasPreview(file);
    if (file && canBePreviewed && !slides.includes(file)) {
        pushSlide(file);
    }
    const name = (file === null || file === void 0 ? void 0 : file.name) || ((_b = (_a = domToReact(domNode === null || domNode === void 0 ? void 0 : domNode.children)) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a));
    return (_jsx("figure", { children: _jsx(FileListItem, { name: name, extension: file === null || file === void 0 ? void 0 : file.extension, size: file === null || file === void 0 ? void 0 : file.size, downloadUrl: (file === null || file === void 0 ? void 0 : file.downloadUrl) || (file === null || file === void 0 ? void 0 : file.url), "data-index": canBePreviewed ? slides.indexOf(file) : 0, onPreview: canBePreviewed && onClick }, void 0) }, void 0));
};
//# sourceMappingURL=AttachmentRenderer.js.map